import clsx from "clsx";

interface Props {
  children: React.ReactNode;
  iconSrc: string;
  title: string;
  className?: string;
}

const FeatureSection = (props: Props) => {
  const { children, className, title, iconSrc } = props;
  return (
    <section className={clsx(className)}>
      <div className="mb-3">
        <img src={iconSrc} alt="icon" className="w-14 h-14 mx-auto mb-3" />
        <div className="text-center text-lg font-bold">{title}</div>
      </div>
      {children}
    </section>
  );
};

export default FeatureSection;
